"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;
exports.ldClientWrapper = ldClientWrapper;
exports.ldOverrideFlag = ldOverrideFlag;
exports.getAllFeatureFlags = getAllFeatureFlags;
exports.identify = identify;

var _ldclientJs = require("ldclient-js");

var _ldclientJs2 = _interopRequireDefault(_ldclientJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var url = require("url");

function getLocation() {
  if (window.location) {
    return window.location.toString();
  }
  return "";
}

var ldClient = void 0;
var ldClientReady = false;
function ldClientWrapper(key, user) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var queue = [];

  if (!ldClient) {
    ldClient = _ldclientJs2.default.initialize(key, user, options);
  }

  if (!ldClientReady) {
    ldClient.on("ready", function () {
      ldClientReady = true;

      if (queue.length) {
        queue.forEach(function (callback) {
          callback();
        });
      }
    });
  }

  // Create our own implementation of the ldclient-js' `on` function.
  // Multiple calls with `on('ready')` seem to not fire after the original client has been initialized.
  // By implementing our own, we can track the initial "ready" fire and decide how to proceed.
  ldClient.onReady = function (callback) {
    if (ldClientReady) {
      callback();
    } else {
      queue.push(callback);
    }
  };

  return ldClient;
}

function ldOverrideFlag(flagKey, typeFlagValue) {
  var override = void 0;
  /*
   POST /users?features=send-onboarding-email
   # Overrides the `send-onboarding-email` boolean feature flag, setting it to `true`
   GET /users/101?features=show-user-email,user-nicknames,hide-inactive-users
   # Enables the `show-user-email`, `user-nicknames`, and `hide-inactive-users` feature flags
   POST /users?features.verify-email=false&features.email-frequency=weekly
   # Disables the `verify-email` feature flag and sets the `email-frequency` variation to "weekly"
   */
  var query = url.parse(exports.getLocation(), true).query;
  var queryFlag = query["features." + flagKey];
  var queryFeatures = query["features"];

  if (typeof queryFlag !== "undefined") {
    if (queryFlag === "") {
      override = true;
    } else if (queryFlag === "false") {
      override = false;
    } else {
      override = queryFlag;
    }

    if (typeFlagValue === "number") {
      override = parseFloat(override);
    }
  } else if (queryFeatures) {
    queryFeatures.split(",").forEach(function (f) {
      if (f === flagKey) {
        override = true;
      }
    });
  }
  return override;
}

function getAllFeatureFlags(key, user) {
  var ldClient = ldClientWrapper(key, user);
  return new Promise(function (resolve) {
    ldClient.onReady(function () {
      resolve(ldClient.allFlags());
    });
  });
}

/*

  https://docs.launchdarkly.com/docs/js-sdk-reference#section-changing-the-user-context

  "The hash parameter is the hash for the new user, assuming that the user's key has changed.
  It is only required in secure mode-- if secure mode is not enabled,
  you can pass in `null` for the hash."

*/
function identify(key, user) {
  var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var ldClient = ldClientWrapper(key, user);
  return new Promise(function (resolve) {
    ldClient.onReady(function () {
      resolve(ldClient.identify(user, hash));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/lib/utils.js
// module id = 572
// module chunks = 0